const doc = [({"false":null, "no":({"js":({"components":({"modal":({})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;